export const textractKeys = {
  all: ['textract'] as const,
  fieldsMapping: (companyId: string | null, documentID: string) =>
    [...textractKeys.all, 'fieldsMapping', companyId, documentID] as const,
};
